import React, { useState, useEffect } from "react";

interface TerminalFooterProps {
  isConnected: boolean;
  isDarkMode: boolean;
  sessionId: string;
  projectName?: string;
  connectionStartTime?: Date;
}

export const TerminalFooter: React.FC<TerminalFooterProps> = ({
  isConnected,
  isDarkMode,
  connectionStartTime,
}) => {
  const [currentTime, setCurrentTime] = useState(() => new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, []);

  const getUptime = () => {
    if (!connectionStartTime) return "00:00:00";

    const now = currentTime.getTime();
    const start = connectionStartTime.getTime();
    const diff = Math.floor((now - start) / 1000);

    const hours = Math.floor(diff / 3600);
    const minutes = Math.floor((diff % 3600) / 60);
    const seconds = diff % 60;

    return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  };

  const containerStyle: React.CSSProperties = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "6px 20px",
    backgroundColor: isDarkMode ? "#0f0f0f" : "#e5e7eb",
    borderTop: isDarkMode
      ? "1px solid rgba(255, 255, 255, 0.05)"
      : "1px solid rgba(0, 0, 0, 0.05)",
    fontSize: "11px",
    fontFamily: "monospace",
    color: isDarkMode ? "#6b7280" : "#9ca3af",
    flexShrink: 0,
    minHeight: "32px",
  };

  const itemStyle: React.CSSProperties = {
    display: "flex",
    alignItems: "center",
    gap: "4px",
  };

  const labelStyle: React.CSSProperties = {
    color: isDarkMode ? "#4b5563" : "#6b7280",
    fontWeight: 500,
  };

  const valueStyle: React.CSSProperties = {
    color: isDarkMode ? "#d1d5db" : "#374151",
    fontWeight: 600,
  };

  return (
    <>
      <div style={containerStyle} className="terminal-footer">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <div className="footer-connection-time">
            {isConnected && (
              <div style={itemStyle}>
                <span style={labelStyle}>Verbindungsdauer:</span>
                <span style={valueStyle}>{getUptime()}</span>
              </div>
            )}

            {!isConnected && (
              <span
                style={{
                  color: isDarkMode ? "#6b7280" : "#9ca3af",
                  fontSize: "11px",
                }}
              >
                Nicht verbunden
              </span>
            )}
          </div>

          <div
            className="footer-support"
            style={{
              color: isDarkMode ? "#4b5563" : "#6b7280",
              fontSize: "10px",
            }}
          >
            <span className="footer-support-label-desktop">
              Support & Feature Requests:{" "}
            </span>
            <span className="footer-support-label-mobile">Support/Ideen: </span>
            <a
              href="mailto:support@mittwald.de"
              style={{
                color: isDarkMode ? "#3b82f6" : "#2563eb",
                textDecoration: "none",
                fontWeight: 500,
              }}
              onMouseEnter={(e) => {
                if (window.matchMedia("(hover: hover)").matches) {
                  e.currentTarget.style.textDecoration = "underline";
                }
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.textDecoration = "none";
              }}
            >
              support@mittwald.de
            </a>
          </div>
        </div>
      </div>
    </>
  );
};
